import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '@/lib/firebase';

/** settings/general (DATA_MODEL.md) — readable by every signed-in user. */
export interface GeneralSettings {
  fullName: string;   // בית הכנסת המרכזי "אהבת שלום" – נוה הפסגה
  shortName: string;  // אהבת שלום — header and menu
  subtitle: string;   // נוה הפסגה
}

export const DEFAULT_GENERAL: GeneralSettings = {
  fullName: 'בית הכנסת המרכזי "אהבת שלום" – נוה הפסגה',
  shortName: 'אהבת שלום',
  subtitle: 'נוה הפסגה',
};

export function useGeneralSettings(): GeneralSettings {
  const [s, setS] = useState<GeneralSettings>(DEFAULT_GENERAL);
  useEffect(() => onSnapshot(
    doc(db, 'settings', 'general'),
    (snap) => {
      const d = (snap.data() ?? {}) as Partial<GeneralSettings>;
      setS({
        fullName: d.fullName || DEFAULT_GENERAL.fullName,
        shortName: d.shortName || DEFAULT_GENERAL.shortName,
        subtitle: d.subtitle ?? DEFAULT_GENERAL.subtitle,
      });
    },
    () => setS(DEFAULT_GENERAL),
  ), []);
  useEffect(() => { document.title = s.shortName; }, [s.shortName]);
  return s;
}
